import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StorageModule } from '@fleetoperate/shared/util';

@NgModule({
  imports: [
    CommonModule,
    StorageModule
  ]
})
export class SharedAuthenticationAuthenticationModule {}
